
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M459.86 72.233l-61.868-43.1a7.92 7.92 0 00-5.973-1.31 7.97 7.97 0 00-5.137 3.298L202.839 295.627a7.937 7.937 0 00-1.349 3.416l-12.138 83.455a7.977 7.977 0 003.337 7.697 7.97 7.97 0 008.38.461l74.013-40.354a7.849 7.849 0 002.729-2.449L461.848 83.348a7.987 7.987 0 00-1.988-11.115zm-194.07 264.95l-58.345 31.806 9.574-65.781 178.4-256.399 48.771 33.966-178.4 256.408zM449.647 189a7.979 7.979 0 00-7.983 7.986v267.967c0 17.137-13.931 31.074-31.059 31.074H73.576c-17.128 0-31.059-13.938-31.059-31.074V127.767c0-17.136 13.931-31.074 31.059-31.074h198.653a7.979 7.979 0 007.983-7.986 7.98 7.98 0 00-7.983-7.986H73.576c-25.93 0-47.025 21.105-47.025 47.047v337.187c0 25.941 21.095 47.047 47.025 47.047h337.03c25.93 0 47.024-21.105 47.024-47.047V196.986a7.978 7.978 0 00-7.983-7.986zm32.245-144.945L417.855 1.344c-3.679-2.448-8.63-1.458-11.069 2.216a7.984 7.984 0 002.213 11.075l64.036 42.71a7.97 7.97 0 004.42 1.342 7.972 7.972 0 006.65-3.557 7.983 7.983 0 00-2.213-11.075z"}})])
          )
        }
      }
    